import { useClientConfig } from 'src/hooks/useClientConfig';

import './WidgetAvatar.sass';

const WidgetAvatar = ({ overrideSrc }: { overrideSrc?: string }) => {
	const client = useClientConfig();
	const botUrl = overrideSrc ?? (client?.bot ? client?.bot?.toString() : `${window?._env_?.HOST_URL}/widget/bot.png`);
	return <div style={{ backgroundImage: `url("${botUrl}")` }} className="widget-avatar" />;
};

export default WidgetAvatar;
